import React, { useEffect, useCallback } from "react";
import { useConfirmation } from "./ConfirmationContext";

const ConfirmationDialog = () => {
  const { isOpen, confirmationConfig, closeConfirmation } = useConfirmation();

  const handleEscapeKey = useCallback(
    (event) => {
      if (event.key === "Escape") {
        closeConfirmation();
      }
    },
    [closeConfirmation]
  );

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("keydown", handleEscapeKey);
    }
    return () => {
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [isOpen, handleEscapeKey]);

  if (!isOpen) return null;

  const {
    title,
    message,
    onConfirm,
    confirmButtonColor = "bg-red-600 hover:bg-red-700",
  } = confirmationConfig;

  const handleConfirm = () => {
    onConfirm();
    closeConfirmation();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999]">
      <div className="bg-gray-800 p-6 rounded-lg max-w-sm w-full m-4">
        <h2 className="text-xl text-white mb-4">{title}</h2>
        <p
          className="text-gray-300 mb-6"
          dangerouslySetInnerHTML={{ __html: message }}
        ></p>
        <div className="flex justify-end space-x-4">
          <button
            onClick={closeConfirmation}
            className="bg-gray-600 text-white px-4 py-2 rounded hover:bg-gray-700"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className={`text-white px-4 py-2 rounded ${confirmButtonColor}`}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationDialog;
